"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackAuthBlockShown = trackAuthBlockShown;
exports.trackAuthenticateSuccess = trackAuthenticateSuccess;
exports.trackChangeLoginFlowTo = trackChangeLoginFlowTo;
exports.trackForgotPasswordClick = trackForgotPasswordClick;
exports.trackForgotPasswordClickMerge = trackForgotPasswordClickMerge;
exports.trackForgotPasswordSubmitSuccess = trackForgotPasswordSubmitSuccess;
exports.trackLoginAnotherWay = trackLoginAnotherWay;
exports.trackLoginNeedHelp = trackLoginNeedHelp;
exports.trackLoginResumeButtonClick = trackLoginResumeButtonClick;
exports.trackResetPasswordGotItClick = trackResetPasswordGotItClick;
exports.trackShowConfirmAccount = trackShowConfirmAccount;
exports.trackShowTwoStepPassword = trackShowTwoStepPassword;
exports.trackShowTwoStepPasswordRegistration = trackShowTwoStepPasswordRegistration;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _tracking = require("../../utils/tracking");
var _constants = require("./constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Показ блока авторизации
 */
function trackAuthBlockShown(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'show'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Успешная авторизация
 */

function trackAuthenticateSuccess(_ref) {
  let {
    socialType,
    senderType,
    source
  } = _ref;
  const label = senderType ? _constants.PHONE_CODE_SENDER_TO_LABEL[senderType] : socialType || '';
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Authorization',
    action: 'success',
    label
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на кнопку "забыли пароль" при авторизации
 */
function trackForgotPasswordClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'forgot_password_click',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Успешная отправка формы "забыли пароль"
 */
function trackForgotPasswordSubmitSuccess(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на кнопку "забыли пароль" при мердже
 */
function trackForgotPasswordClickMerge(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_forgot_password',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик по кнопке "хорошо" после запроса ссылки на восстановление
 */
function trackResetPasswordGotItClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'reset_password_got_it'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на кнопку "Войти по email или id" или "Войти по телефону"
 * @param {TAuthFlow} flow - flow type
 */
function trackChangeLoginFlowTo(flow, source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: flow === 'email' ? 'login_email_ID' : 'login_phone'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля при пошаговой форме
 */
function trackShowTwoStepPassword(element, source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password_input',
    label: element
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля при пошаговой форме для нового пользователя
 */
function trackShowTwoStepPasswordRegistration(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'make_new_password_input'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на кнопку прололжить в форме пошаговой авторизации
 */
function trackLoginResumeButtonClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'email_continue'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик по ссылке нужана помощь для флоу авторизации/регистрации по email/id
 */
function trackLoginNeedHelp(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'reсovery_password_cant_confirm'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Клик на кнопку "Выбрать другой аккаунт"
 */
function trackLoginAnotherWay(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'login_another_way'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля после экрана выбора аккаунта
 */
function trackShowConfirmAccount(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Authorization',
    action: 'Open',
    label: 'password_input_popup'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}